<div
  id="user"
  class="page-layout blank p-24"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    <div
      class="name"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      <button mat-icon-button (click)="getReturnUrl()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      @if (microsoftUser) {
        {{ this.microsoftUser.displayName }}
      }
    </div>
  </div>
  <!-- / HEADER -->
  <div class="content-card" fxFill>
    <!-- CONTENT -->
    <div class="content" fxLayout="column">
      <div class="content upper-side" fxLayout="row wrap">
        <div
          fxLayout="column"
          fxFlex="30"
          fxFlex.md="30"
          class="card-profile-container">
          <mat-card class="mat-card profile-card">
            <div
              class="card-header"
              fxLayout="row"
              fxLayoutAlign="space-between center">
              <h2 class="card-title">
                {{ '365-USER-PAGE.CARD-TITLE.PROFILE-TITLE' | translate }}
              </h2>
              <div class="button-section refresh-button">
                <button
                  mat-icon-button
                  aria-label="refresh"
                  (click)="refreshData()"
                  class="search-button-action">
                  <mat-icon class="refresh-icon">refresh</mat-icon>
                </button>
              </div>
            </div>
            @if (!isBusyRetrieveMicrosoftInfo) {
              <div class="profile-picture" fxLayoutAlign="center center">
                <img
                  class="profile-image"
                  [src]="
                    microsoftUser.photoBase64
                      ? microsoftUser.photoBase64
                      : 'assets/images/avatars/avatar.png'
                  "
                  [@animate]="{
                    value: '*',
                    params: { delay: '50ms', scale: '1' },
                  }"
                  alt="Avatar du profil" />
              </div>
              <mat-list role="list" class="user-info-list">
                <mat-list-item class="username">
                  <div matListItemTitle>
                    {{ this.microsoftUser.surname }}
                    {{ this.microsoftUser.givenName }}
                  </div>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>school</mat-icon>
                  <h4 matListItemTitle class="nobreak">
                    {{ this.microsoftUser.officeLocation }}
                  </h4>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>language</mat-icon>
                  <h4 matListItemTitle class="nobreak">
                    {{
                      this.microsoftUser.preferredLanguage === 'fr-ch'
                        ? 'Français'
                        : 'Allemand'
                    }}
                  </h4>
                </mat-list-item>
                @if (this.microsoftUser.mail) {
                  <mat-list-item>
                    <mat-icon matListItemIcon>alternate_email</mat-icon>
                    <h4 matListItemTitle class="nobreak">
                      {{ this.microsoftUser.mail }}
                    </h4>
                  </mat-list-item>
                }
                <mat-list-item fxLayout="row">
                  <span class="abp-icon" matListItemIcon>ABP</span>
                  <h4 matListItemTitle class="nobreak">
                    {{ this.microsoftUser.abp }}
                  </h4>
                </mat-list-item>
              </mat-list>
            }
            @if (isBusyRetrieveMicrosoftInfo) {
              <div
                class="general-container"
                fxLayout="row"
                fxLayoutAlign="center center">
                <mat-progress-spinner
                  [color]="spinner.color"
                  [mode]="spinner.mode"
                  [value]="spinner.value"
                  [diameter]="spinner.diameter">
                </mat-progress-spinner>
              </div>
            }
          </mat-card>
        </div>
        <div
          fxFlex="70"
          fxFlex.md="70"
          fxLayout="row"
          class="licenses-sharedmailboxes">
          <div
            fxLayout="column"
            fxFlex="50"
            fxFlex.md="50"
            fxLayout="column"
            class="card-profile-container">
            <app-licenses-table [userLicenses]="licenses" />
          </div>
          <div
            fxLayout="column"
            fxFlex="50"
            fxFlex.md="50"
            fxLayout="column"
            class="card-profile-container">
            <app-sharedmailboxes-table
              [userEmail]="userEmail" />
          </div>
        </div>
      </div>
      <div 
      fxFlex="100"
      fxFlex.md="100"
      fxLayout="row"
      class="content groups-user-content">
      <!-- DON'T DELETE
          <div
          fxLayout="column"
          fxFlex="70"
          fxFlex.md="70"
          class="card-profile-container">
              <app-groups-table [userId]="userId" />
          </div>
      </div>-->
          <div
          fxLayout="column"
          fxFlex="100"
          fxFlex.md="100"
          class="card-profile-container">
              <app-teams-table [userId]="userId" />
          </div>
      </div>
    </div>
  </div>
</div>
